// extracted by css-extract-rspack-plugin
export default {"container":"hJyN5OUZk7IkHIms","body":"A1aB58JskMcnZCdh"};